import React, { Component } from 'react';
import Link from 'react-router-dom/NavLink';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Button from '../../../shared/components/Button';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import {
  alphabeticallySort,
  textContains
} from '../../../shared/utils';

class Brands extends Component {
  constructor(){
    super();

    this.state = {
      filter:''
    }
  }

  handleSearchUpdate(event){
    this.setState({filter:event.target.value});
  }
  handleCreateClick(){}

  getFilteredBrands(){
    const filterParam = this.state.filter.toLowerCase();

    return this.props.brands
      .filter((brand) => brand.name !== null)
      .filter((brand) => brand.name.toLowerCase().indexOf(filterParam) >= 0)
      .sort((a,b) => a.name.localeCompare(b.name));
  }

  getStatusForBrand(brand){
    if(brand.active) return 'Activated';
    return 'Suspended'
  }

  getCampaignCountForBrand(brand){
    return this.props.campaigns.filter((c) => c.companyId === brand.id).length
  }

  userFromContactId(contactId){
    const contact = this.props.users.filter((u) => u.id === contactId)[0];
    if(contact){
      return contact;
    } else {
      return {
        firstName:'',
        lastName:'',
        emaail:''
      }
    }
  }

  render(){
    const { match, updateBrand, brands  } = this.props;

    return (
      <Container className='Brands'>
        <Row className='EntityList-title'>
          <Col xs='6'>
            {/* <Input
              placeholder='Search...'
              value={this.state.filter}
              onChange={this.handleSearchUpdate.bind(this)}
            /> */}
            <h1>Brands</h1>
          </Col>
          <Col xs='6'>
            <Button
              linkHref={`${this.props.match.url}/new`}
              className='float-right'
              onClick={this.handleCreateClick.bind(this)}
              >
                Add Brand
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md='6' xs='12'>
            <p>
              Assign a brand name and logo for your consumers to view while engaging with your experiences.  We'll filter reporting based on brand to help organize your data.
            </p>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <SearchableDataTable
              items={brands}
              hideSearch
              emptyText='No brands associated with this account'
              searchPromptText='Search by name'
              columns={[
                {
                  name:'logo',
                  width:20,
                  renderCell:(item) => (
                    <div className={!item.active ? 'deactivated' : ''}>
                      {item.logoURL ? (
                        <img
                          style={{ height:50 }}
                          src={item.logoURL}
                          alt={`Logo for brand ${item.name}`}
                        />
                      ) : (
                        <span>N/A</span>
                      )}
                    </div>
                    )
                },{
                  display:'Name',
                  name:'name',
                  width:40,
                  sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                  filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                  renderCell:(item) => (
                    <div className={!item.active ? 'deactivated' : ''}>
                      <Link to={`${match.url}/${item.id}`}>{item.name}</Link>
                    </div>
                    )
                },{
                  display:'Experiences',
                  name:'totalCampaigns',
                  width:20,
                  sortFunc:(a,b) => this.getCampaignCountForBrand(b) - this.getCampaignCountForBrand(a),
                  renderCell:(item) => (
                    <div className={!item.active ? 'deactivated' : ''}>
                      {this.getCampaignCountForBrand(item)}
                    </div>
                  )
                },{
                  width:20,
                  renderCell:(item) => (
                    <div className='pull-right'>
                      <Button
                        size='sm'
                        linkHref={`${match.url}/${item.id}`}
                        textColor='#666666'
                        borderColor='#cccccc'
                        backgroundColor='#fff'
                      >
                        Edit
                      </Button>
                      &nbsp;&nbsp;
                      <DropdownButton
                        options={[
                          {
                            text:item.active ? 'Deactivate' : 'Activate',
                            onClick:() => updateBrand(item.id,{active:!item.active})
                          }
                        ]}
                      />
                    </div>
                  )
                }

              ]}
            />
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default Brands;



// WEBPACK FOOTER //
// ./src/routes/Brands/components/Brands.js